import React, { Component } from 'react';
import RichTextInput from 'ra-input-rich-text';
import { addField } from 'ra-core';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

class RichTextInputWithSource extends Component {
  state = { showSource: false };

  toggleSource = () => {
    this.setState(prev => ({ showSource: !prev.showSource }));
  };

  handleSourceChange = e => {
    this.props.input.onChange(e.target.value);
  };

  render() {
    const { showSource } = this.state;
    const { input, meta, fullWidth = true, ...rest } = this.props;
    const { touched, error } = meta || {};

    return (
      <FormControl error={!!(touched && error)} fullWidth={fullWidth}>
        <div style={{ marginBottom: 4 }}>
          <Button size="small" variant="outlined" onClick={this.toggleSource}>
            {showSource ? 'Editor' : 'HTML'}
          </Button>
        </div>
        {showSource ? (
          <textarea
            value={input.value || ''}
            onChange={this.handleSourceChange}
            style={{
              width: '100%',
              minHeight: 200,
              fontFamily: 'monospace',
              fontSize: 13,
              padding: 8,
              border: '1px solid #ccc',
              borderRadius: 4
            }}
          />
        ) : (
          <RichTextInput {...rest} input={input} meta={meta} />
        )}
        {touched && error && (
          <FormHelperText error>{error}</FormHelperText>
        )}
      </FormControl>
    );
  }
}

const RichTextInputWithSourceField = addField(RichTextInputWithSource);

RichTextInputWithSourceField.defaultProps = {
  addLabel: true,
  fullWidth: true
};

export default RichTextInputWithSourceField;
